import { useState, useEffect, useMemo } from "react";
import { departmentService } from "../dependencyInjection";
import { Department } from "../services/DepartmentService";

type UseGetDepartmentsList = (paramSort?: number) => void;
type UseCreateDepartment = (DepartmentInfo: Department) => Promise<boolean>;
type UseUpdateDepartment = (DepartmentInfo: Department) => void;
type UseDeleteDepartment = (DepartmentId: number) => void;
type UseAdministrationResult = [Department[], boolean, UseGetDepartmentsList, UseCreateDepartment, UseUpdateDepartment, UseDeleteDepartment];

export function useAdminDepartment(): UseAdministrationResult {
  const [departments, setDepartments] = useState<Department[]>([]);
  const [pendind, setPending] = useState(false);
  useEffect(() => {
    // TODO: Вынести строитель фунции отписки в утилиты
    const sub = departmentService.departments$.subscribe((DepartmentList) => {
      const filtredData = DepartmentList.filter(x => !x.isDeleted);
      setDepartments(filtredData);
    });
    const subLoading = departmentService.loading$.subscribe((loading) => {
      setPending(loading);
    });
    return () => {
      sub.unsubscribe();
      subLoading.unsubscribe();
    };
  }, []);

  const getDepartmentsList = useMemo<UseGetDepartmentsList>(
    () => async (paramSort?: number) => {
      try {
        await departmentService.getDepartmentsList(paramSort);
      } catch (e) {}
    },
    [],
  );

  const createDepartment = useMemo<UseCreateDepartment>(
    () => async (DepartmentInfo: Department) => {
      try {
        return await departmentService.createDepartment(DepartmentInfo);
      } catch (e) {
        return false;
      }
    },
    [],
  );

  const updateDepartment = useMemo<UseUpdateDepartment>(
    () => async (DepartmentInfo: Department) => {
      try {
        await departmentService.updateDepartment(DepartmentInfo);
      } catch (e) {}
    },
    [],
  );

  const deleteDepartment = useMemo<UseDeleteDepartment>(
    () => async (DepartmentId: number) => {
      try {
        await departmentService.deleteDepartment(DepartmentId);
      } catch (e) {}
    },
    [],
  );

  return [departments, pendind, getDepartmentsList, createDepartment, updateDepartment, deleteDepartment];
}
